import React from 'react';

import type { Props } from '@travel/traveler-core/components/WithSkeletonLoading';
import WithSkeletonLoadingCore from '@travel/traveler-core/components/WithSkeletonLoading';

function WithSkeletonLoading(props: Props) {
  return <WithSkeletonLoadingCore {...props} />;
}

export default WithSkeletonLoading;
